import {sdk} from '~ui/services/sdk';

type Deps = {
    sdk: typeof sdk;
};

export type WikiEpicDeps = Deps;
export type WikiThunkExtra = Deps;

const deps: Deps = {
    sdk,
};

export const epicDeps: WikiEpicDeps = deps;
export const thunkExtra: WikiThunkExtra = deps;
